import { generateUuidV4Regex } from "@/common/helpers/utils";
import { NotFoundView } from "@/views/common/notfound.view";
import { Route, Switch } from "wouter";
import { AppRoleCreateView } from "./app-role-create.view";
import { AppRoleUuidUpdateView } from "./app-role-uuid-update.view";
import { AppRoleView } from "./app-role.view";
import { AttributeView } from "./attribute/attribute.view";

export function AppRoleRoutes() {
  const appRoleUuidUpdate = generateUuidV4Regex({
    paramName: "appRoleUuid",
    suffix: "/update",
  });

  return (
    <Switch>
      <Route path={"/create"} component={AppRoleCreateView} />
      <Route path={"/attribute"} component={AttributeView} />
      <Route path={appRoleUuidUpdate} component={AppRoleUuidUpdateView} />
      <Route path={"/"} component={AppRoleView} />
      <Route component={NotFoundView} />
    </Switch>
  );
}
